import * as init from './001-init'

export default {
  '001': init,
}
